export const Tablefields = [
  {
    key: 'order_date',
    label: 'Order Date',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'status_change_date',
    label: 'Received Date',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'waybill_number',
    label: 'Waybill Number',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'merchant_data',
    label: 'Merchant',
    thClass: 'text-left',
    tdClass: 'text-left',
    sortable: true,
    formatter: value => (value && value.name ? value.name : ''),
  },
  {
    key: 'customer_name',
    label: 'Customer Name',
    thClass: 'text-left',
    tdClass: 'text-left',
    sortable: true,
  },
  {
    key: 'customer_address',
    label: 'Customer Address',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'customer_phone',
    label: 'Customer Phone',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'destination_warehouse',
    label: 'Destination Warehouse',
    thClass: 'text-left',
    tdClass: 'text-left',
    formatter: value => (value && value.name ? value.name : ''),
  },
  {
    key: 'temporary_warehouse',
    label: 'Temporary Warehouse',
    thClass: 'text-left',
    tdClass: 'text-left',
    formatter: value => (value && value.name ? value.name : ''),
  },
  {
    key: 'weight',
    label: 'Weight',
    thClass: 'text-right',
    tdClass: 'text-right',
  },
  {
    key: 'cod_amount',
    label: 'COD',
    thClass: 'text-right',
    tdClass: 'text-right',
  },
  {
    key: 'order_current_status',
    label: 'Status',
    thClass: 'text-left',
    tdClass: 'text-left',
    formatter: value => (value && value.name ? value.name : ''),
  },
]
// eslint-disable-next-line
export const json_fieldz = {
  'Order Date': {
    field: 'order_date',
    // eslint-disable-next-line no-underscore-dangle
    callback: value => this.__dateTimeFormatter(value),
  },
  'Received Date': {
    field: 'status_change_date',
    // eslint-disable-next-line no-underscore-dangle
    callback: value => this.__dateTimeFormatter(value),
  },
  'Waybill Number': 'waybill_number',
  Merchant: {
    callback: value => `"${value.merchant_data && value.merchant_data.name ? value.merchant_data.name : ''}"`,
  },
  'Customer Name': {
    field: 'customer_name',
    callback: value => `"${value}"`,
  },
  'Customer Address': {
    field: 'customer_address',
    callback: value => `"${value}"`,
  },
  'Customer Phone': 'customer_phone',
  'Second Phone Number': 'customer_secondary_phone',
  'Destination Warehouse': {
    callback: value => `"${value.destination_warehouse && value.destination_warehouse.name ? value.destination_warehouse.name : ''}"`,
  },
  'Temporary Warehouse': {
    callback: value => `"${value.temporary_warehouse && value.temporary_warehouse.name ? value.temporary_warehouse.name : ''}"`,
  },
  Weight: 'weight',
  COD: 'cod_amount',
  Status: {
    callback: value => `"${value.order_current_status && value.order_current_status.name ? value.order_current_status.name : ''}"`,
  },
}
